module.exports = __webpack_public_path__ + "img/img31.a20c8e7f.svg";